import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import Map from 'ol/Map'
import Zoomify from 'ol/source/Zoomify'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Tile from 'ol/layer/Tile'
import View from 'ol/View'
import Draw, {
  createBox,
  createRegularPolygon,
} from 'ol/interaction/Draw';
import {
  Modify,
  Select,
  Translate
} from 'ol/interaction';
import GeoJSON from 'ol/format/GeoJSON'
import Polygon from 'ol/geom/Polygon';
import * as olExtent from 'ol/extent';
import Feature from 'ol/Feature';
import {Fill, Style, Stroke} from 'ol/style'
@Component({
  selector: 'app-openlayer',
  templateUrl: './openlayer.component.html',
  styleUrls: ['./openlayer.component.sass']
})
export class OpenlayerComponent implements OnInit, OnChanges, AfterViewInit {
  mapOl: Map
  mapSize = [];
  viewOl: View
  draw: any;
  vectorDrawLayer: any;
  vectorDrawSource: any;
  drawings: any = [];
  zoomifyLayer: Tile;
  zoomifySource: Zoomify
  retinaSource: Zoomify;
  selectedFeature
  settimout
  settimout2
  settimout3

  select
  translate
  modify

  @Input() _zoomifyUrl: string = "https://dmql6z22jzc51.cloudfront.net/zoomify/5c4fee4c36c3d3794d400f12/1548815922319/ImageProperties.xml"
  @Input() isZoomifyRetina: boolean
  @Input() _zoomifyWidth: number = 7276
  @Input() _zoomifyHeight: number = 90000
  @Input() _drawings: any;
  @Input() _drawMode: string = 'None'
  @Input() _deleteSelected: string
  @Input() zoomAfterDraw: boolean = true
  @Input() screenshotAfterDraw: boolean = true
  @Input() zoomFitToFeature
  @Input() enableEdit: string
  @Input() drawColor: string
  @Output() _drawnItems: EventEmitter<any> = new EventEmitter()
  @Output() onScreenshotCaptured: EventEmitter<any> = new EventEmitter()
  @Output() featuresClicked: EventEmitter<any> = new EventEmitter()

  constructor() { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.zoomifySource = new Zoomify({
      url: this._zoomifyUrl.replace("ImageProperties.xml", ""),
      size: [this._zoomifyWidth, this._zoomifyHeight],
      crossOrigin: "anonymous",
      zDirection: -1
    })
    const zoomifyExtent = this.zoomifySource.getTileGrid().getExtent();

    const retinaPixelRatio = 2;
    // this.retinaSource = new Zoomify({
    //   url: "https://dmql6z22jzc51.cloudfront.net/zoomify/5c4fee4c36c3d3794d400f12/1548815922319/ImageProperties.xml".replace("ImageProperties.xml", ""),
    //   size: [this._zoomifyWidth, this._zoomifyHeight],
    //   crossOrigin: "anonymous",
    //   zDirection: -1, // Ensure we get a tile with the screen resolution or higher
    //   tilePixelRatio: retinaPixelRatio, // Display retina tiles
    //   tileSize: 256 / retinaPixelRatio // from a higher zoom level
    // });

    this.zoomifyLayer = new Tile({
      source: this.zoomifySource
    });

    this.vectorDrawSource = new VectorSource({ wrapX: false });
    this.vectorDrawLayer = new VectorLayer({ source: this.vectorDrawSource });

    this.select = new Select({
      wrapX: false,
    });
    this.select.getFeatures().on('add', feature => {
      this.selectedFeature = feature
    });
    
    this.modify = new Modify({
      features: this.select.getFeatures(),
    });
    this.modify.on('modifyend', e => {
      this.getAllFeatures()
      if (this.screenshotAfterDraw) {
        let that = this
        this.mapOl.once('rendercomplete', function () {
          that.screenshotMap([...that.mapSize]).then((ss) =>
            that.onScreenshotCaptured.emit(ss)
          );
        });
        this.mapOl.renderSync();
      }
    })

    this.translate = new Translate({
      features: this.select.getFeatures(),
    });
    this.translate.on('translateend', e => {
      this.getAllFeatures()
      if (this.screenshotAfterDraw) {
        let that = this
        this.mapOl.once('rendercomplete', function () {
          that.screenshotMap([...that.mapSize]).then((ss) =>
            that.onScreenshotCaptured.emit(ss)
          );
        });
        this.mapOl.renderSync();
      }
    })

    this.viewOl = new View({
      resolutions: this.zoomifyLayer.getSource().getTileGrid().getResolutions(),
      extent: zoomifyExtent,
      constrainOnlyCenter: true
    })

    this.mapOl = new Map({
      // interactions: defaultInteractions().extend([this.select, this.translate, this.modify]),
      layers: [this.zoomifyLayer, this.vectorDrawLayer],
      target: "openlayerMap",
      view: this.viewOl,
      controls: []
    });
    this.mapOl.getView().fit(zoomifyExtent);
    this.mapOl.getView().setZoom(6);
    this.mapSize = this.mapOl.getSize();
    
    this.mapOl.on('click', event => {
      this.featuresClicked.emit(this.mapOl.getFeaturesAtPixel(event.pixel))
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    const {isZoomifyRetina, _drawMode, _drawings, _deleteSelected, zoomFitToFeature, enableEdit, drawColor} = changes

    if (_deleteSelected && _deleteSelected.currentValue !== undefined && this.selectedFeature) {
      this.vectorDrawSource.removeFeature(this.selectedFeature.element);
      this.selectedFeature.target.remove(this.selectedFeature.element);
      this.selectedFeature = null
      this.getAllFeatures()
    }

    if (enableEdit && this.mapOl) {
      if (enableEdit.currentValue) {
        this.mapOl.addInteraction(this.select)
        this.mapOl.addInteraction(this.translate)
        this.mapOl.addInteraction(this.modify)
      } else {
        this.mapOl.removeInteraction(this.select)
        this.mapOl.removeInteraction(this.translate)
        this.mapOl.removeInteraction(this.modify)
      }
    }

    if (_drawMode && _drawMode.currentValue !== undefined) {
      let mode = _drawMode.currentValue
      const drawOption = {
        source: this.vectorDrawSource,
        type: mode
      }
      switch (mode) {
        case 'None':
          this.mapOl?.removeInteraction(this.draw)
          break;
        case 'Square':
          drawOption.type = 'Circle';
          drawOption['geometryFunction'] = createRegularPolygon(4);
          this.buildDraw(drawOption)
          break;
        case 'Box':
          drawOption.type = 'Circle';
          drawOption['geometryFunction'] = createBox();
          this.buildDraw(drawOption)
          break;
        default:
          this.buildDraw(drawOption)
          break;
      }
    }

    if (_drawings) {
      this.vectorDrawSource?.clear()
      if (_drawings.currentValue?.length > 0) {
        this.placeDrawingOntopOpenlayer(_drawings.currentValue);
      }
    }

    if (zoomFitToFeature && zoomFitToFeature.currentValue?.length > 0) {
      this._zoomFitToFeature(zoomFitToFeature.currentValue)
    }

    if (drawColor) {
      const hexColor = drawColor.currentValue
      this.vectorDrawSource?.forEachFeature(feature => {
        // console.log(hexColor)
        // {strokeColor: drawColor.currentValue ?? "#009AD1"}
        let style = new Style({
          stroke: new Stroke({
            color: drawColor.currentValue ? hexToRgb(hexColor) : hexToRgb("#009AD1"),
            width: 1
          }),
          fill: fill
        })
        // console.log(style)
        feature.setStyle(style)
      })
      this.mapOl?.once('rendercomplete', () => {
        this.screenshotMap([...this.mapSize]).then((ss) =>
          this.onScreenshotCaptured.emit(ss)
        );
      });
    }
  }

  getAllFeatures(e?) {
    clearTimeout(this.settimout)
    this.settimout = setTimeout(() => {
      var geom = [];
      this.vectorDrawSource.forEachFeature(feature => {
        const g = feature.getGeometry()
        if (typeof g.getRadius === "function" && typeof g.getCenter === "function") {
          var coor = g.getCenter();
          var rad = g.getRadius();
          const manualCircularPoly = new Polygon([circularPolygonCoor(coor, rad)]);
          geom.push(new Feature({ geometry: manualCircularPoly }));
        } else {
          geom.push(
            new Feature(
              feature.getGeometry()
            )
          );
        }
      });
      var writer = new GeoJSON();
      var geoJsonStr = writer.writeFeatures(geom);

      this._drawnItems.emit(geoJsonStr)
      return JSON.parse(geoJsonStr);
    });
  }

  buildDraw(drawOption) {
    if (!this.mapOl) return;
    this.mapOl.removeInteraction(this.draw);
    this.draw = new Draw(drawOption)
    this.draw.on("drawend", (e) => {
      this.mapOl.removeInteraction(this.draw);

      this.getAllFeatures(e)

      if (this.zoomAfterDraw) {
        var polygon = e.feature.getGeometry();
        this.viewOl.fit(polygon, {padding: [100, 400, 100, 100], duration: 1000});

        this.mapOl.once('moveend', () => {
          if (this.screenshotAfterDraw) {
            let that = this
            this.mapOl.once('rendercomplete', function () {
              that.screenshotMap([...that.mapSize]).then((ss) =>
                that.onScreenshotCaptured.emit(ss)
              );
            });
            this.mapOl.renderSync();
          }
        });
      }
    });

    this.draw.on('propertychange', e => console.log('propertychange', e))

    this.mapOl.addInteraction(this.draw);
  }

  screenshotMap(mapSize): Promise<string> {
    if (mapSize === undefined) {
      return new Promise((resolve, reject) => {
        resolve('null');
      });
    }
    var mapCanvas = document.createElement('canvas');
    mapCanvas.width = mapSize[0];
    mapCanvas.height = mapSize[1];
    var mapContext = mapCanvas.getContext('2d');
    Array.prototype.forEach.call(
      document.querySelectorAll('.ol-layer canvas'),
      function (canvas) {
        if (canvas.width > 0) {
          var opacity = canvas.parentNode.style.opacity;
          mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
          var transform = canvas.style.transform;
          // Get the transform parameters from the style's transform matrix
          var matrix = transform
            .match(/^matrix\(([^\(]*)\)$/)[1]
            .split(',')
            .map(Number);
          // Apply the transform to the export map context
          CanvasRenderingContext2D.prototype.setTransform.apply(
            mapContext,
            matrix
          );
          mapContext.drawImage(canvas, 0, 0);
        }
      }
    );
    const img = mapCanvas.toDataURL();
    return new Promise((resolve, reject) => {
      if (img) {
        resolve(img);
      }
    });
  }

  placeDrawingOntopOpenlayer(drawings) {
    const parsedDrawings = drawings.map(i => JSON.parse(i))
    clearTimeout(this.settimout2)
    this.settimout2 = setTimeout(() => {
      for (let i = 0; i < parsedDrawings.length; i++) {
        var geojson = new GeoJSON().readFeatures(parsedDrawings[i]);
        this.vectorDrawSource.addFeatures(geojson);
        this.vectorDrawLayer.setStyle(feature => {
          let severity = feature.get('severity_type')
          return new Style({
            stroke: new Stroke({
              color: severity?.description ? hexToRgb(severity?.description) : hexToRgb("#009AD1"),
              width: 1
            }),
            fill: fill
          })
        })
      }
    });
  }

  _zoomFitToFeature(features) {
    features = features.map(i => JSON.parse(i))
    clearTimeout(this.settimout3)
    this.settimout3 = setTimeout(() => {
      var geojson = new GeoJSON().readFeatures(features[0])
      var extent = geojson[0].getGeometry().getExtent().slice(0)

      for (let i = 1; i < features.length; i++) {
        var geojson = new GeoJSON().readFeatures(features[i])
        olExtent.extend(extent,geojson[0].getGeometry().getExtent())
      }

      this.viewOl.fit(extent, {
        padding: [100, 400, 100, 100],
        duration: 1000
      });
    });
  }
}

export interface OpenLayerAnnotation {
  openlayerScreenshot?: string,
  openlayerDrawings?: any[],
  zoomFitToFeature?: any[],
  maplayerid?: string,
  enableEdit?: string,
  drawColor?: string
}

function circularPolygonCoor(center, radius, n = 64) {
  const step = 360 / n;
  let angle = step;
  let countr = 0;
  let coordinates = [];

  let Cx = center[0];
  let Cy = center[1];

  while (angle <= 360) {
    countr += 1;

    const theta = ((angle - 90) * Math.PI) / 180;
    const x = Cx + (radius * Math.cos(theta))
    const y = Cy + (-radius * Math.sin(theta))

    coordinates.push([x, y]);
    angle += step;
  }
  coordinates.push(coordinates[0]);

  return coordinates;
}

const fill = new Fill({
  color: [255, 255, 255, .4]
})

const basic = new Style({
  stroke: new Stroke({
    color: [64, 200, 200, 1],
    width: 1
  }),
  fill: fill
})

// const level1 = new Style({
//   stroke: new Stroke({
//     color: [127, 255, 0, 1],
//     width: 1
//   }),
//   fill: fill
// })

export function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16),
    1
  ] : [0,0,0,1];
}